import React, {Component} from 'react';
import {BootstrapTable, TableHeaderColumn} from "react-bootstrap-table";
import {TopButtonPointEdit, TopButtonPointRemove} from "../../../../../../componentsTopsa/buttons/TopButtons";
import tabgrid from "../../../../../../utilities/TabGrid";
import TabUtilities from "../../../../../../utilities/TabUtilities";


export default class FerieTable extends Component {
    constructor(props) {
        super(props);
        this.state = {
        };
        this.renderButtonyAkcji = this.renderButtonyAkcji.bind(this)
    }

    renderButtonyAkcji(cell,row){
        return(
            <div>
                <TopButtonPointEdit onClick={()=>{this.props.handleEdytuj(row)}} titleContent={'Edytuj ferie'} />
                <TopButtonPointRemove onClick={()=>{this.props.handleUsun(row)}} titleContent={'Usuń ferie'} />
            </div>
        )
    }

    render() {

        const options = {
            sizePerPage: 15,
            sizePerPageList: [10, 15, 30],
            noDataText: 'Brak pasujących rekordów'
        };
        return (
            <div>
                <BootstrapTable data={this.props.data}
                                options={options}
                                pagination
                                hover
                >
                    <TableHeaderColumn dataField='id' isKey hidden={true}>ID</TableHeaderColumn>
                    <TableHeaderColumn dataField='dataOd' dataSort
                                       thStyle={tabgrid.tg11} tdStyle={tabgrid.tg11}
                                       filter={(this.props.wlaczSzukanie) ? {type: 'TextFilter', delay: 500, placeholder: 'Szukaj'} : false}
                    >Data od</TableHeaderColumn>
                    <TableHeaderColumn dataField='dataDo' dataSort
                                       thStyle={tabgrid.tg11} tdStyle={tabgrid.tg11}
                                       filter={(this.props.wlaczSzukanie) ? {type: 'TextFilter', delay: 500, placeholder: 'Szukaj'} : false}
                    >Data do</TableHeaderColumn>
                    <TableHeaderColumn dataField='id'
                                       thStyle={tabgrid.tg3} tdStyle={tabgrid.tg3}
                                       dataFormat={this.renderButtonyAkcji}
                    >{TabUtilities.returnAkcjeEdytujUsunHtml()}</TableHeaderColumn>

                </BootstrapTable>
            </div>
        );
    }
}




// WEBPACK FOOTER //
// ./src/modules/konfiguracja/rozkladConfig/kalendarze/ferie/components/FerieTable.js